module.exports = __webpack_public_path__ + "static/media/noImage.2170fd3b.png";